module.exports = __webpack_public_path__ + "static/media/ascend-logo.30356928.png";